import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CaptchaEndpoints as Endpoints,
  type GetCaptchaRequest,
  type GetCaptchaResponse,
  type TestCaptchaRequest,
  type TestCaptchaResponse,
} from '@app/api/Captcha/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

export const captchaApi = createApi({
  reducerPath: 'captchaApi',
  baseQuery: createApiBaseQuery('/Captcha'),
  endpoints: ({ query }) => ({
    [Endpoints.GetCaptcha]: query<GetCaptchaResponse, GetCaptchaRequest>({
      query: (params) => ({
        url: Endpoints.GetCaptcha,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.TestCaptcha]: query<TestCaptchaResponse, TestCaptchaRequest>({
      query: (params) => ({
        url: Endpoints.TestCaptcha,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetCaptchaQuery,
  useLazyGetCaptchaQuery,
  useTestCaptchaQuery,
  useLazyTestCaptchaQuery,
} = captchaApi;
